// phonics_data_lt08.js
// Letter Teams L08 - L8 Long Vowel Sounds ai, ay
// 路由：/phonics/lt08

const MEDIA_BASE = '/media/phonics/lt08';
const V = 'v1';

export const letterDataLt08 = {
  id: 'lt08',
  letter: 'L08',
  title: 'L8 Long Vowel Sounds ai, ay',  // 从 PPT P1 提取
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1) → part1.mp4
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3) → part3.mp4
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）→ review.png
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P7/P8/P9: 三段故事（只有英文台词，无中文）
  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "It was a nice day.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "The pals were on a trail.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Pink saw a snail.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Then the day was gray.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "Oh no! It will rain!", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "Rain came down.", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "The trail got wet.", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "We must go home.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "I see a rail.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "Here comes a train.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "We must go fast.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "The pals ran to the train.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Stop!", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "The sun is out now!", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "We can still play.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "No. let's go home.", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "We can play with clay.", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "Yay!", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
      ],
    },
  ],
};
